import { commonUtils } from './common_utils';
import { santander } from './finance/santander';
import { rahoituskumppani } from './finance/rahoituskumppani';
import { etua } from './finance/etua';
import { kattokorko } from './finance/kattokorko';
import { autoraha } from './finance/autoraha';
import { opSeller } from './finance/op_seller';
import { opDealer } from './finance/op_dealer';
import { toyotaJousto, toyotaOsamaksu } from './finance/toyota';
import { rahoitustie } from './finance/rahoitustie';

const compareFinance = {
    isTrackImpression: false,
    showCompareFinance() {
        let $section = $('#compareFinanceSection');
        $section.show();

        $('html, body').animate({ scrollTop: $section.offset().top }, 600, function () {
            $section.find('input:first').focus();
        });

        // Datalayer event, use :first to get only one set of finance providers to avoid duplicates
        if (compareFinance.isTrackImpression === false) {
            compareFinance.isTrackImpression = true;
            let financeCalculators = [];
            $.each($('#financeCalculators:first .financeName'), function () {
                let financeName = $(this).data('name');
                financeCalculators.push(financeName);
            });

            if (financeCalculators.length) {
                commonUtils.dataLayer.viewFinanceButtonDataLayerEvent(financeCalculators);
            }
        }
    },
    setRandomPosition() {
        let randomCalculator = $('.randomCalc');
        $.each(randomCalculator, function () {
            let target = commonUtils.generateRandomNumber(randomCalculator.length);
            let target2 = commonUtils.generateRandomNumber(randomCalculator.length);
            randomCalculator.eq(target).before(randomCalculator.eq(target2));
        });
    },
    showFinanceOptions() {
        let $showFinanceOptions = $('#showFinanceOptionsDesktop,#showFinanceOptionsMobile');
        let adId = $showFinanceOptions.data('ad-id');
        let registrationNumber = $showFinanceOptions.data('registration-number');
        let price = $showFinanceOptions.data('price');
        let adPrice = $showFinanceOptions.data('ad-price');
        let adKilometers = $showFinanceOptions.data('ad-kilometers');
        let userId = $showFinanceOptions.data('user-id') || '';
        let siteCode = $showFinanceOptions.data('sitecode') || '';
        let postedBy = $showFinanceOptions.data('posted-by');
        let params = new URLSearchParams({
            adId,
            registrationNumber,
            price,
            adPrice,
            adKilometers,
            userId,
            siteCode,
            postedBy,
        }).toString();

        if ($showFinanceOptions.length && adId) {
            let $financeProviderLoader = $('.financeProviderLoader');
            $financeProviderLoader.show();
            $.get(Routing.generate('show_vif_finance_options'), params, function (response) {
                // Set minimum month price to Header info section.
                if (response?.finance_minimum_month_price) {
                    $('.financeMinimumMonthPrice').html(response.finance_minimum_month_price);
                }

                // display dmsFinance minimum month price over finance calculators data
                const $dmsFinanceMonthPrice = $(`#dmsMonthlyPaymentPrice${adId}`);
                const dmsFinanceMonthPriceText = $dmsFinanceMonthPrice.text();
                if ($dmsFinanceMonthPrice.length > 0 && dmsFinanceMonthPriceText) {
                    $('.financeMinimumMonthPrice').html(
                        `${Translations.finance_offer_short} ${dmsFinanceMonthPriceText}`
                    );
                }

                if (response?.show_finance_option_html_desktop && response?.show_finance_option_html_mobile) {
                    $('#showFinanceOptionsDesktop').html(response.show_finance_option_html_desktop).show();
                    $('#showFinanceOptionsMobile').html(response.show_finance_option_html_mobile).show();
                    $('#compareFinanceOptions').html(response.compare_finance_options_html);

                    // Check if showFinanceOptionsMobile is empty and add is-empty class to parent
                    const showFinanceOptionsMobile = document.getElementById('showFinanceOptionsMobile');
                    const financeCards = showFinanceOptionsMobile?.closest('.finance-cards');
                    const cardForFinance = showFinanceOptionsMobile?.closest('.card-for-finance');

                    if (showFinanceOptionsMobile?.innerHTML.trim() === '') {
                        financeCards?.classList.add('is-empty');
                        cardForFinance?.classList.add('is-empty');
                    } else {
                        financeCards?.classList.remove('is-empty');
                        cardForFinance?.classList.remove('is-empty');
                    }
                }
            }).always(function () {
                $financeProviderLoader.hide();
            });
        }
    },
};

$(function () {
    let $body = $('body');
    // Show compare finance options
    $body.on('click', '#showCompareFinance', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }

        compareFinance.showCompareFinance();

        // Load default year selection.
        let defaultLoanYears = 5;
        santander.loadYear(defaultLoanYears);
        rahoituskumppani.loadYear(defaultLoanYears);
        autoraha.loadYear(defaultLoanYears);
        etua.loadYear(defaultLoanYears);
        kattokorko.loadYear(defaultLoanYears);
        opSeller.loadYear(defaultLoanYears * 12);
        rahoitustie.loadYear(defaultLoanYears);
        // opDealer has 6, as default year
        defaultLoanYears = 6;
        opDealer.loadYear(defaultLoanYears * 12);

        // Display finance options on random position
        compareFinance.setRandomPosition();
    });

    // Show/Hide tooltip
    $body.on('click', '.showHideToolTip', function () {
        commonUtils.showHideToggle(`${$(this).data('finance-name')}_example_tooltip`);
    });

    // Validate & correct amount
    $body.on('input', '.financeLoanAmount', function () {
        commonUtils.allowInteger($(this));
    });

    // Finance Datalayer event
    $body.on('click', '.financeEvent', function () {
        let bankName = $(this).closest('form').data('bank-name');
        let linkText = $(this).data('link-text');
        commonUtils.dataLayer.dataLayerEventWithLink(bankName, linkText, 'text popup');
    });

    // On click more info
    $body.on('click', '.loanMoreInfo', function () {
        let bankName = $(this).closest('form').data('bank-name');
        let linkText = $(this).data('link-text');
        let loanUrl = $(this).data('loan-url');
        let target = $(this).data('target') || '_blank';
        commonUtils.dataLayer.dataLayerEventWithLink(bankName, linkText, loanUrl.replace(/\/\d+$/, ''));
        if (target === '_blank') {
            let newWindow = window.open(loanUrl, target, 'noopener,noreferrer');
            if (newWindow) {
                newWindow.opener = null;
            }
        } else {
            window.open(loanUrl, target);
        }
        return false;
    });

    // Santander: Calculate finance on change amount or year
    $body.on('change', '#loan_amount, #loan_period', function () {
        santander.slider();
    });

    // Santander: On click Get loan button
    $body.on('submit', '#santanderLoan', function (event) {
        event.preventDefault();
        santander.submit($(this));
    });

    // Rahoituskumppani : Calculate finance on change amount or year
    $body.on('change', '#rahoituskumppaniLoanAmount, #rahoituskumppaniLoanPeriod', function () {
        rahoituskumppani.slider();
    });

    // Rahoituskumppani : On click Get loan button
    $body.on('submit', '#rahoituskumppaniLoan', function (event) {
        event.preventDefault();
        rahoituskumppani.submit($(this));
    });

    // Etua : Calculate finance on change amount or year
    $body.on('change', '#etuaLoanAmount, #etuaLoanPeriod', function () {
        etua.slider();
    });

    // Etua : On click Get loan button
    $body.on('submit', '#etuaLoan', function (event) {
        event.preventDefault();
        etua.submit($(this));
    });

    // Kattokorko : Calculate finance on change amount or year
    $body.on('change', '#kattokorkoLoanAmount, #kattokorkoLoanPeriod', function () {
        kattokorko.slider();
    });

    // Kattokorko : On click Get loan button
    $body.on('submit', '#kattokorkoLoan', function (event) {
        event.preventDefault();
        kattokorko.submit($(this));
    });

    // Ops : Calculate finance on change amount or year
    $body.on('change', '#opsLoanAmount, #opsLoanPeriod', function () {
        opSeller.slider();
    });

    // Ops : On click Get loan button
    $body.on('submit', '#opSellerLoan', function (event) {
        event.preventDefault();
        opSeller.submit($(this));
    });

    // Opd : Calculate finance on change amount or year
    $body.on('change', '#opdLoanAmount, #opdLoanPeriod', function () {
        opDealer.slider();
    });

    // Opd : On click Get loan button
    $body.on('submit', '#opDealerLoan', function (event) {
        event.preventDefault();
        opDealer.submit($(this));
    });

    // Toyota : On change down payment
    $body.on('change', '#toyotaDownPayment', function () {
        if ('ToyotaEasy' === $('#toyotaLoan').data('bank-name')) {
            toyotaJousto.downPayment();
        } else {
            toyotaOsamaksu.downPayment();
        }
    });

    // Toyota : On change bigger last payment
    $body.on('change', '#toyotaBiggerLastPayment', function () {
        if ('ToyotaEasy' === $('#toyotaLoan').data('bank-name')) {
            toyotaJousto.balloonAmount();
        } else {
            toyotaOsamaksu.balloonAmount();
        }
    });

    // Toyota : On change months
    $body.on('change', '#toyotaFullContractPeriod', function () {
        if ('ToyotaEasy' === $('#toyotaLoan').data('bank-name')) {
            toyotaJousto.fullContractPeriod();
        } else {
            toyotaOsamaksu.calculate();
        }
    });

    // Toyota : Calculate finance on change amount or year
    $body.on('change', '#toyotaMileagePerYear', function () {
        toyotaJousto.mileagePerYear();
    });

    // Toyota : On click Get loan button
    $body.on('submit', '#toyotaSubmitLoan', function (_event) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent($(this).data('bank-name'));
    });

    // Autoraha : Calculate finance on change amount or year
    $body.on('change', '#autorahaLoanAmount, #autorahaLoanPeriod', function () {
        autoraha.slider();
    });

    // Autoraha : On click Get loan button
    $body.on('submit', '#autorahaLoan', function (event) {
        event.preventDefault();
        autoraha.submit($(this));
    });

    // Rahoituskumppani : Calculate finance on change amount or year
    $body.on('change', '#rahoitustieLoanAmount, #rahoitustieLoanPeriod', function () {
        rahoitustie.slider();
    });

    // Rahoituskumppani : On click Get loan button
    $body.on('submit', '#rahoitustieLoan', function (event) {
        event.preventDefault();
        rahoitustie.submit($(this));
    });

    compareFinance.showFinanceOptions();

    // dmsFinance for VIF page
    $body.on('click', '.financeTooltipVif', function () {
        $('.dmsFinanceTooltip').toggle();
    });

    // also close dmsFinanceTooltip if clicked outside
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.financeTooltipVif').length) {
            $('.dmsFinanceTooltip').hide();
        }
    });
});
